import { put, call, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import PaymentFactory from "../../Entity/Factories/PaymentFactory";
import { PaymentInterface } from "../../Entity/Entities/Payment/PaymentInterface";
import Translator from "../../Translation/Translator";

export default function* paymentSnooze(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_PAYMENT_SNOOZE_UPDATE_REQUEST
    })

    let requestPayload: any = {};
    if (action.payload) {
      requestPayload.snoozeDate = action.payload?.snoozeDate;
    }

    const res = yield call(Http.put, `payment/${action.payload?.paymentId}/snooze`, {...requestPayload});
    const payment: PaymentInterface = PaymentFactory.create(res.data.data);

    yield put({
      type: Constants.GLOBAL_PAYMENT_SNOOZE_UPDATE_SUCCESS,
      payload: {
        payment: payment
      }
    });

    yield put({
      type: Constants.GLOBAL_CHARGES_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.GLOBAL_PAYMENTS_LIST_OUTDATE_REQUESTS
    })
        
    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: payment?.isSnoozed ? Translator.trans("snackbar-message-payment-snooze-updated-successfully") : Translator.trans("snackbar-message-payment-unsnooze-updated-successfully"),
        type: "success"
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, res.data.data);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_PAYMENT_SNOOZE_UPDATE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchPaymentSnooze() {
  yield takeEvery(Constants.GLOBAL_PAYMENT_SNOOZE_UPDATE_START, paymentSnooze);
}
